export const isMac = navigator.userAgent.includes('Mac');